<template>
	<div class="ab-wrap-content">
		<a id="About" name="About"></a>
		<h3 v-html="translations.abTitle"></h3>
		<div class="ab-wrap-section">
			<p v-html="translations.abContent1"></p>
			<div class="ab-text-spacer"></div>
			<p v-html="translations.abContent2"></p>
			(<a
				href="https://stanfordmag.org/contents/wearable-devices-that-tell-you-when-you-re-getting-sick"
				target="_blank"
				v-html="translations.abContent3"
			></a
			>)
			<p v-html="translations.abContent4"></p>
			<div class="ab-text-spacer"></div>
			<p v-html="translations.abContent5"></p>
			<div class="ab-text-spacer"></div>
			<p v-html="translations.abContent6"></p>
			<ul>
				<li v-html="translations.abContent7"></li>
				<li v-html="translations.abContent8"></li>
				<li v-html="translations.abContent9"></li>
				<li v-html="translations.abContent10"></li>
			</ul>
			<p v-html="translations.abContent11"></p>
			<div class="ab-text-spacer"></div>
			<p v-html="translations.abContent12"></p>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'About',
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				abTitle: this.$t('abTitle'),
				abContent1: this.$t('abContent1'),
				abContent2: this.$t('abContent2'),
				abContent3: this.$t('abContent3'),
				abContent4: this.$t('abContent4'),
				abContent5: this.$t('abContent5'),
				abContent6: this.$t('abContent6'),
				abContent7: this.$t('abContent7'),
				abContent8: this.$t('abContent8'),
				abContent9: this.$t('abContent9'),
				abContent10: this.$t('abContent10'),
				abContent11: this.$t('abContent11'),
				abContent12: this.$t('abContent12'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.ab-wrap-section {
	font-size: 20px;
	color: var(--main-color-text-light);
	height: fit-content;
	background-color: #ffffff40;
	padding: 10px 5vw;
	box-sizing: border-box;
	text-align: justify;
}

.ab-text-spacer {
	height: 20px;
}
</style>
